import { merge } from 'lodash';
import { Tarea, TareaBasica } from './tarea.model';
import { CampoDinamico } from './global.model';
import { Static } from './../util/static';

export type ActividadTiposEstado = 'active' | 'inactive' | 'pending' | 'finished';

/**
 * Clase base con propiedades estándar para construir
 * otras clases de este archivo.
 *
 * @export
 * @class TramiteBase
 */
export class ActividadBase {
  id: number;
  nombre: string;
  descripcion: string;
  meta?: ActividadMetaData;
}

/**
 * Información extra generada de la actividad.
 *
 * @export
 * @class ActividadMetaData
 */
export class ActividadMetaData {
  // Indice de la actividad dentro del array de actividades.
  index: number;
  // Indice de la última actividad dentro del array de actividades.
  indexLast: number;
  // Define si esta actividad es la última dentro del array de actividades.
  isLast: boolean;
  // Índice que se muestra al usuario en el flujo.
  indexFlow: number;
}

/**
 * Actividad de un tramite por default o de una instancia.
 *
 * Los endpoints que satisface son:
 * instanceDefaultTramite, microprocesInstance, instanceTramite.
 *
 * @export
 * @class Actividad
 */
export class Actividad extends ActividadBase {
  orden: number;
  actividad_estado: ActividadBase;
  tarea_padre: number | null;
  tareas: Tarea[];

  constructor(values: Partial<Actividad>) {
    super();
    Static.setAll(
      this,
      merge(
        {
          orden: 1,
          tarea_padre: null,
          tareas: []
        },
        values
      )
    );
  }
}

/**
 * Consulta los datos necesarios para generar el calendario de actividades.}
 *
 * Los endpoints que satisface son: activity-calendar.
 *
 * @export
 * @class ActividadCalendario
 */
export class ActividadCalendario {
  id: number;
  nombre: string;
  actividad: string;
  fecha_activacion: Date;
  id_tramite: number;
  nombre_tramite: string;
  microproceso: number | null;
  secundaria: number | null;
  proceso: number;
  categoria: number;
  rechazable: boolean;
  tramite_expediente: number;
  tramite_radicado_expediente: string;
  campos: CampoDinamico[];
}

/**
 * Modelo de las actividades de la consulta del tramite basico
 *
 * @export
 * @class ActividadBasica
 * @extends {ActividadBase}
 */
export class ActividadBasica extends ActividadBase {
  orden: number;
  actividad_estado: ActividadBase;
  tarea_padre: number | null;
  tareas: TareaBasica[];

  constructor(values: Partial<Actividad>) {
    super();
    Static.setAll(
      this,
      merge(
        {
          orden: 1,
          tarea_padre: null,
          tareas: []
        },
        values
      )
    );
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/models/actividad.model.ts